export interface BillingModalInvoicesCrudFormState {
    realTotalValueKey: number
}
export const initialBillingModalInvoicesCrudFormState =
    (): BillingModalInvoicesCrudFormState => ({
        realTotalValueKey: 0
    })
